module.exports = __webpack_public_path__ + "img/logo.230e0194.png";